(function () {
	function slideUp(element, duration = 300) {
		if (!element) return;
		element.style.height = element.offsetHeight + "px";
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.boxSizing = "border-box";
		element.style.overflow = "hidden";
		// Force repaint
		element.offsetHeight;
		element.style.height = "0px";
		element.style.paddingTop = "0px";
		element.style.paddingBottom = "0px";
		element.style.marginTop = "0px";
		element.style.marginBottom = "0px";

		window.setTimeout(() => {
			element.style.display = "none";
			element.style.removeProperty("height");
			element.style.removeProperty("padding-top");
			element.style.removeProperty("padding-bottom");
			element.style.removeProperty("margin-top");
			element.style.removeProperty("margin-bottom");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	function slideDown(element, duration = 300) {
		if (!element) return;
		element.style.removeProperty("display");
		let display = window.getComputedStyle(element).display;
		if (display === "none") display = "block";
		element.style.display = display;

		const height = element.scrollHeight;
		element.style.overflow = "hidden";
		element.style.height = "0px";
		element.style.paddingTop = "0px";
		element.style.paddingBottom = "0px";
		element.style.marginTop = "0px";
		element.style.marginBottom = "0px";
		// Force repaint
		element.offsetHeight;
		element.style.boxSizing = "border-box";
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.height = height + "px";
		element.style.removeProperty("padding-top");
		element.style.removeProperty("padding-bottom");
		element.style.removeProperty("margin-top");
		element.style.removeProperty("margin-bottom");

		window.setTimeout(() => {
			element.style.removeProperty("height");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	function handleToggleClick(event) {
		const toggle = event.target.closest(".collapsible-content__toggle");
		if (!toggle) return;

		event.preventDefault();

		const parent = toggle.closest(".collapsible-content__item--main");
		if (!parent) return;

		const answer = parent.querySelector(".collapsible-content__answer");
		if (!answer) return;

		const itemsContainer = toggle.closest(".collapsible-content__items");
		const isCurrentlyActive = parent.classList.contains("active");

		// Close any other open accordion items in the same section
		if (itemsContainer) {
			const activeMains = itemsContainer.querySelectorAll(
				".collapsible-content__item--main.active"
			);
			activeMains.forEach((otherMain) => {
				if (otherMain !== parent) {
					otherMain.classList.remove("active");
					const otherAnswer = otherMain.querySelector(
						".collapsible-content__answer"
					);
					if (otherAnswer) {
						slideUp(otherAnswer, 300);
					}
				}
			});
		}

		if (!isCurrentlyActive) {
			parent.classList.add("active");
			slideDown(answer, 300);
		} else {
			parent.classList.remove("active");
			slideUp(answer, 300);
		}
	}

	// Use event delegation on document so dynamic sections are automatically handled
	document.addEventListener("click", handleToggleClick);
})();
